import React from 'react'
import { Copy } from 'lucide-react'
import toastr from '@/lib/notifications'
import { cn } from '@/lib/utils'

class CopyToClipboard extends React.Component {

  constructor(props) {
    super(props)

    this.onCopy = this.onCopy.bind(this)
  }

  onCopy(e) {
    if (e) {
      e.preventDefault()
    }

    const content = this.props.content || ''

    if (navigator.clipboard) {
      navigator.clipboard.writeText(content).then(() => {
        toastr.success("Copied to clipboard.")
      })
    }
    else {
      toastr.success("Clipboard is not available. Are you browsing in secure context?")
    }
  }

  render() {
    return (
      <span className={cn('cursor-pointer', this.props.className)} style={this.props.style} onClick={this.onCopy}>
        {this.props.children || <Copy className="inline size-3.5 text-muted-foreground" />}
      </span>
    )
  }
}

export default CopyToClipboard
